import * as React from 'react';
import { EntityConfig, entityStandardFormFields } from '@shapeable/core';
import { SpeciesType as MyType } from '@shapeable/kelp-forest-alliance-types';

export const SpeciesType: EntityConfig<MyType> = {
  name: 'SpeciesType',
  label: "Species Type",
  type: 'taxonomy',
//   icon: ({ icons }) => icons.Entities.Chapter,
  autoRoutes: ['list', 'create', 'update'],
  form: {
    fields: {
      ...entityStandardFormFields,
      description: { type: 'longText' },
    }
  }
};